import React from 'react';
import { Link } from 'react-router-dom';

const TONE_CLASSES = [
  'donezo-stat-card--tone-0',
  'donezo-stat-card--tone-1',
  'donezo-stat-card--tone-2',
  'donezo-stat-card--tone-3',
];

const ICON_VARIANTS = ['', '--alt1', '--alt2', '--alt3'];

/**
 * Dashboard summary stat tile.
 */
export default function DashboardStatCard({
  title,
  value,
  icon,
  to,
  colClass = 'col-xl-3 col-md-6',
  colorIndex = 0,
}) {
  const tone = TONE_CLASSES[colorIndex % TONE_CLASSES.length];
  const variant = ICON_VARIANTS[colorIndex % ICON_VARIANTS.length];
  const iconClass = `donezo-stat-icon${variant ? ` donezo-stat-icon${variant}` : ''}`;

  const card = (
    <div className={`donezo-stat-card donezo-stat-card--metric ${tone}`}>
      <div className={iconClass}>
        <i className={`fa ${icon} fa-fw`} aria-hidden />
      </div>
      <div className="donezo-stat-body">
        <div className="donezo-stat-title">{title}</div>
        <div className="donezo-stat-value">{value}</div>
      </div>
    </div>
  );

  return (
    <div className={colClass}>
      {to ? (
        <Link to={to} className="donezo-stat-card-link">
          {card}
        </Link>
      ) : (
        card
      )}
    </div>
  );
}
